// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__2iA-w","rotate":"styles_rotate__L3Q61"};